import { cn } from "@/utils/functions";
import { Select } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GoPlus } from "react-icons/go";
import { IoFunnelOutline } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";

export default function Filter({ setPageConfig, filters, extraFilter }) {
  const { t } = useTranslation();
  const [selectedFilters, setSelectedFilters] = useState([]);

  if (!Array.isArray(filters)) return null;
  const handleChange = (value, name) => {
    setPageConfig((prev) => {
      return {
        ...prev,
        [name]: value,
        page: 1,
      };
    });
  };

  const filteredFromSelected = filters?.filter((item) =>
    selectedFilters?.includes(item?.key)
  );
  const filteredFromUnSelected = filters?.filter(
    (item) => !selectedFilters?.includes(item?.key)
  );

  return (
    <div className="flex items-center gap-2">
      {extraFilter || null}
      {filteredFromSelected.map((item) => {
        const { className, popupClassName } = item;
        return (
          <div key={item.key} className="flex filterTag  pr-2">
            <div
              className={cn(
                "filterTag float-left min-w-[100px] max-w-[150px]",
                {
                  [className]: className,
                }
              )}>
              <Select
                placeholder={item.label}
                className=""
                mode={item.mode || "multiple"}
                popupClassName={cn("", {
                  [popupClassName]: popupClassName,
                })}
                showSearch={false}
                style={{ width: "100%" }}
                maxTagPlaceholder={(item) => (
                  <div className="">{item.length} {t("common.selected")}</div>
                )}
                maxTagCount={0}
                onChange={(value) => handleChange(value, item.key)}>
                {item.options?.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <button
              className="flex items-center justify-center p-1 hover:bg-gray-200 rounded-r-md rounded-l-none transition-colors bg-gray-200"
              onClick={() => {
                setSelectedFilters((prev) => {
                  return prev.filter((n) => n !== item.key);
                });
                setPageConfig((prev) => {
                  const prevTemp = { ...prev };
                  delete prevTemp[item.key];
                  return prevTemp;
                });
              }}>
              <RxCross2 />
            </button>
          </div>
        );
      })}
      {/* تم إخفاء زر "+ تصفية" القديم - تم استبداله بنظام الفلترة المتقدم */}
    </div>
  );
}
